import * as Config from '../../../config';
import { useEffect } from 'react';
import { connect, useSelector, useDispatch } from "react-redux";
import { addNCRoot, clearTypeNCRoot } from "./redux/actions/index";

// Allow to select menus / playlists / tracks
// with keyboards arrows left / right
// but also with any controller knob `select track`
// Enter with the `tab` keyboard or press the controller knob.
function ConnectedNavControlWrapper({ playlists, root, content, state }) {
  const dispatch = useDispatch();
  const isConnected = useSelector(state => state.isConnected);

  // Init Tab Bar Navigation In Root - Related to the actual available elements
  useEffect(() => {
    /*(isConnected) &&*/ dispatch(clearTypeNCRoot(`tabbar`));
    dispatch(addNCRoot({ ref: `ref-prev`, link: `ref-prev`, action: `class`, scroll: true, type: `tabbar`, order: -2 }));
    dispatch(addNCRoot({ ref: `ref-next`, link: `ref-next`, action: `class`, scroll: true, type: `tabbar`, order: -1 }));
  }, [isConnected, dispatch])

  // Init Playlists Navigation In Root
  useEffect(() => {
    dispatch(clearTypeNCRoot(`playlist`));
    if (playlists && playlists.length > 0) {
      playlists.filter(x => !x.pm).slice(0).reverse().forEach( (x, i) => {
        dispatch(addNCRoot({ ref: `ref-${x.id}`, link: `link-ref-${x.id}`, action: `class`, scroll: true, type: `playlist`, order: 20 + i }));
      } )
      // Recently Played
      dispatch(addNCRoot({ ref: `ref-rp`, link: `link-ref-rp`, action: `class`, scroll: true, type: `playlist`, order: 21 + playlists.length }));
    }
  }, [playlists, dispatch])

  // Navigation Management Root + Chilldren
  useEffect(() => {
    if (state) {
      let action = state.action;
      const [currentlevel, currentIndex] = state.current;
      const [lastLevel, lastIndex] = state.last;

      root.sort(Config.sortAlpha(`order`, true));

      if (action === `back`) {
        action = `direction`;
      }

      if (action === `select`  && lastIndex !== null) {
        const el = (lastLevel === 0) ? root[lastIndex] : content[lastIndex];
        // console.log(`ACTIVE`, lastLevel, lastIndex, content);
        if (el && el.link && document.getElementById(el.link)) {
          document.getElementById(el.link).click();
          if (el.action === `class` && el.ref) { document.getElementById(el.ref).classList.add("NC"); }
        }
      }

      if (action === `direction` && currentIndex !== null) {
        const [lastLevel, lastIndex] = state.last;
        // console.log(`NC WRAPPER`, currentlevel, currentIndex);
        content.sort(Config.sortAlpha(`order`, true));
        const previousEl = (lastLevel === 0) ? root[lastIndex] : content[lastIndex];
        const el = (currentlevel === 0) ? root[currentIndex] : content[currentIndex];

        if (previousEl && previousEl.action === `class` && previousEl.ref) {
          if (document.getElementById(previousEl.ref)) {
            document.getElementById(previousEl.ref).classList.remove("NC");
          }
        }
        if (el && el.action === `class` && el.ref) {
          if (document.getElementById(el.ref)) {
            document.getElementById(el.ref).classList.add("NC");
            document.getElementById(el.ref).scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }

        if (previousEl && previousEl.action === `click` && previousEl.ref) {
          if (document.getElementById(previousEl.ref)) {
            document.getElementById(previousEl.ref).classList.remove("selected");
          }
        }
        if (el && el.action === `click` && el && el.ref) {
          if (document.getElementById(el.ref)) {
            document.getElementById(el.ref).classList.add("selected");
            document.getElementById(el.ref).click();

            const rect = document.getElementById(el.ref).getBoundingClientRect();
            const parent = document.getElementById(el.ref).parentNode.getBoundingClientRect()
            const limitTop = parent.top;
            const limitBottom = parent.top + parent.height;
            if (rect.top <= limitTop || rect.top >= limitBottom || rect.top+rect.height > limitBottom) {
              if (el.scroll) {
                document.getElementById(el.ref).scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                });
              }
            }
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  return null;
}

const NavControlWrapper = connect(
  state => ({
    root: state.NCRoot,
    content: state.NCContent,
    state: state.NCState,
    playlists: (state.storePlaylists) ? state.storePlaylists.playlists : []
  })
)(ConnectedNavControlWrapper);

export default NavControlWrapper;
